import React from "react";
import { HiCursorClick } from "react-icons/hi";

export const EmptyDetail: React.FC = () => (
  <div className="flex items-center justify-center min-h-[480px] p-8">
    <div className="text-center space-y-2 max-w-xs">
      <HiCursorClick className="w-8 h-8 text-[var(--foreground-muted)] mx-auto opacity-50" />
      <p className="text-sm text-[var(--foreground-muted)]">
        Pick a scenario from the list to view its definition, latest run, or
        verdict.
      </p>
    </div>
  </div>
);
